<template>
  <div class="member-tile">
    <a v-if="hasLink" :href="data.linkedin" class="member-text link" target="_blank">
      <p class="member-text name">{{ data.name }}</p>
    </a>
    <p v-else class="member-text name">{{ data.name }}</p>
  </div>
</template>

<script>
export default {
  name: "MemberTile",
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  computed: {
    hasLink() {
      return this.data.linkedin !== "";
    }
  }
}
</script>

<style lang="scss">
.member-tile {
  //width: fit-content;
  text-align: center;
  break-inside: avoid;
  margin-bottom: .5em;

  .member-text {
    text-decoration: none; /* Remove underline from text */
    color: var(--medium);
    padding: 0;
    margin: 0;

    &.link { /* Apply specific styles for the link class */
      &:hover {
        cursor: pointer;
        text-decoration: underline; /* Add underline on hover */
      }

      &:focus {
        outline: 2px dashed var(--regular);
        outline-offset: 4px;
        border-radius: var(--border-radius-sm);
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .member-tile {
    margin-bottom: 0.25rem;

    .member-text {
      font-size: 0.82rem;
      line-height: 1.3;
    }
  }
}
</style>